module.exports = __webpack_public_path__ + "img/burkina-faso.12880c26.svg";